import { useMemo } from 'react'
import extractTourV2DepartureDetails from 'lib/tours/extractTourV2DepartureDetails'

function useTourV2DepartureDetails(
  departure: Tours.V2OfferDeparture,
): ReturnType<typeof extractTourV2DepartureDetails> {
  return useMemo(() => extractTourV2DepartureDetails(departure), [departure])
}

export default useTourV2DepartureDetails
